import { NgModule } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from '@routingModule';
import { SharedModule } from '../../../shared/shared.module';
import { MaterialModule } from '@modules/material.module';
import { PainelFinanceiroComponent } from './components/painel-financeiro.component';
import { PainelFinanceiroApiService } from './services/painel-financeiro-api.service';
import { PainelFinanceiroResolver } from './painel-financeiro.resolver';
import { PrimengModule } from '@modules/primeng.module';



@NgModule({
  declarations: [
    PainelFinanceiroComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    MaterialModule,
    PrimengModule,
  ],
  providers: [
    { provide: PainelFinanceiroApiService, useClass: PainelFinanceiroApiService },
    PainelFinanceiroResolver
  ],
})
export class PainelFinanceiroModule { }